<template>
  <div class="order-container">
    <Header title="往来账确认书"></Header>
    <Search @onFilter="onFilter" :keyName="keyName"></Search>
    <Scroll
      ref="wrapper"
      :listenScroll="false"
      :pullUpLoad="pullUpLoadObj"
      @pullingUp="onPullUpLoad"
      :pullDownRefresh="pullDownRefreshObj"
      @pullingDown="onPullDownRefresh"
    >
      <InvoiceCard :qualificationList="qualificationList"></InvoiceCard>
      <!-- <van-empty
        v-if="dataEmpty"
        class="custom-empty"
        description="暂无数据"
      ></van-empty> -->
    </Scroll>

    <van-popup
      v-model="filterFlag"
      position="right"
      :overlay="true"
    >
      <FilterList
        :brandList="brandList"
        @refreshData="refreshData"
      ></FilterList>
    </van-popup>

  </div>
</template>
<script>
import Header from "../../../components/Header.vue";
import Search from "./components/Search.vue";
import InvoiceCard from "./components/InvoiceCard";
import FilterList from "./components/FilterList";
import CurrentApi from "@/request/CurrentApi";
import commonApi from "@/request/commonApi";
import Scroll from "@/components/Scroll";
export default {
  name: "Funds",
  components: {
    Header,
    Search,
    InvoiceCard,
    FilterList,
    Scroll,
  },
  data() {
    return {
      keyName: "输入订单号/交货单号/发票号码",
      orderStatus: "0",
      filterFlag: false,
      orderList: [],
      sellers: [],
      brandList: [
        {
          name: "状态",
          key: "sellers",
          multiple: true,
          close: false,
          list: [
            {
              name: "全部",
              key: "commodity",
              multiple: true,
              close: false,
            },
            {
              name: "待审核",
              key: "commodityName",
              multiple: true,
              close: false,
            },
            {
              name: "已生效",
              key: "orderType",
              multiple: true,
              close: false,
            },
            {
              name: "已驳回",
              key: "orderStatus",
              multiple: true,
              close: false,
            },
          ],
        },
      ],
      searchForm: {
        sellerEnterpriseCode: "",
        tradeType: "", // 订单类型
        status: "", //订单状态
        statusList: [],
        productLine: "",
      },
      hasNextPage: true,
      scrollParams: {
        pullDownRefresh: true,
        pullDownRefreshThreshold: 90,
        pullDownRefreshStop: 40,
        pullUpLoad: true,
        pullUpLoadThreshold: 0,
        pullUpLoadMoreTxt: "",
        pullUpLoadNoMoreTxt: "",
      },
      formPage: {
        currentPage: 1,
        pageSize: 10,
      },
    };
  },
  computed: {
    pullUpLoadObj() {
      return this.scrollParams.pullUpLoad
        ? {
            threshold: parseInt(this.scrollParams.pullUpLoadThreshold),
            txt: {
              more: this.scrollParams.pullUpLoadMoreTxt,
              noMore: this.scrollParams.pullUpLoadNoMoreTxt,
            },
          }
        : false;
    },
    pullDownRefreshObj() {
      return this.scrollParams.pullDownRefresh
        ? {
            threshold: parseInt(this.scrollParams.pullDownRefreshThreshold),
            stop: parseInt(this.scrollParams.pullDownRefreshStop),
          }
        : false;
    },
    statusType() {
      return this.$store.state.valueSet.NG_ORDER_STATUS;
    },
    orderType() {
      return this.$store.state.valueSet.NG_ORDER_TYPE;
    },
    LNGmaterialCode() {
      return this.$common.interfacePath.LngMaterialCode;
    },
    PNGmaterialCode() {
      return this.$common.interfacePath.PngMaterialCode;
    },
    dataEmpty() {
      return this.orderList.length == 0 && !this.loading;
    },
  },
  watch: {},
  created() {
    this.getBrandList();
  },
  methods: {
    onFilter() {
      this.filterFlag = !this.filterFlag;
    },
    //上拉加载
    onPullUpLoad() {
      if (!this.hasNextPage) {
        this.$refs.wrapper.forceUpdate(false);
        return false;
      } else {
        setTimeout(() => {
          this.formPage.currentPage++;
          this.getOrderList();
        }, 1000);
      }
    },
    //下拉刷新
    onPullDownRefresh() {
      setTimeout(() => {
        this.formPage.currentPage = 1;
        this.orderList = [];
        this.getOrderList();
      }, 1000);
    },
    refreshData(queryList) {
      this.onFilter();
      this.searchForm = this.$options.data().searchForm;
      for (let i = 0; i < queryList.length; i++) {
        let item = queryList[i];
        if (item.key == "commodityName") {
          let productTypes = item.list.filter((info) => {
            return info.selected == true && info.key != "all";
          });
          if (productTypes.length > 0) {
            this.searchForm.productLine = productTypes[0].key;
          }
          continue;
        }
        if (item.key == "sellers") {
          let sellers = item.list.filter((info) => {
            return info.selected == true && info.key != "all";
          });
          if (sellers.length > 0) {
            this.searchForm.sellerEnterpriseCode = sellers[0].key;
          }
          continue;
        }
        if (item.key == "orderType") {
          let types = item.list.filter((info) => {
            return info.selected == true && info.key != "all";
          });
          if (types.length > 0) {
            this.searchForm.tradeType = types[0].key;
          }
          continue;
        }
        if (item.key == "orderStatus") {
          let status = item.list.filter((info) => {
            return info.selected == true && info.key != "all";
          });
          if (status.length > 0) {
            this.Pagedata.status = status[0].key;
          }
          continue;
        }
      }

      this.orderList = [];
      this.formPage.currentPage = 1;
      this.getOrderList();
    },
    async getOrderList() {
      let params = Object.assign({}, this.searchForm, this.formPage);
      CurrentApi.getOrderList(params).then((res) => {
        if (res.returnCode == "0") {
          let tempList = res.result.dataList;
          for (let i in tempList) {
            tempList[i].createTime = tempList[i].createTime
              ? this.$utils.formatDateTime(tempList[i].createTime)
              : "--";
            tempList[i].amount = this.$utils.amount(tempList[i].amount);
            tempList[i].deliveryDateEnd = this.$utils.formatDateTime(
              tempList[i].deliveryDateEnd
            );
          }
          this.orderList = this.orderList.concat(tempList);
          // this.Pagedata.currentPage++;
          this.hasNextPage = res.result.hasNextPage;
          if (this.hasNextPage) {
            this.$refs.wrapper.forceUpdate(true);
          } else {
            this.$refs.wrapper.forceUpdate(false);
          }
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }
      });
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    cancelOrder(item) {
      this.$dialog
        .confirm({
          title: "提示",
          message: "是否确定取消订单？",
        })
        .then(() => {
          let params = {
            id: item.id,
            auditOpinion: "",
            status: "99",
          };
          CurrentApi.cancel(params).then((res) => {
            if (res.returnCode == "0") {
              this.$toast({
                type: "success",
                message: "取消成功",
                duration: 1500,
              });
              this.getOrderList();
            } else {
              this.$toast({
                type: "fail",
                message: res.returnMessage,
                duration: 1500,
              });
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    getSellers() {
      commonApi.lngListSeller().then((res) => {
        if (res.returnCode == "0") {
          this.sellers = res.result;
        }
      });
    },
    async getBrandList() {
      let res = await commonApi.lngListSeller();
      if (res.returnCode == "0") {
        this.sellers = res.result;
      }
      this.brandList.map((brand) => {
        if (brand.key == "sellers") {
          this.sellers.forEach((i) => {
            let item = {};
            item.key = i.salesUnitCode;
            item.name = i.salesUnitName;
            brand.list.push(item);
          });
          console.log(brand.list);
        }
        if (brand.key == "orderType") {
          this.orderType.forEach((i) => {
            let item = {};
            item.key = i.itemCode;
            item.name = i.itemName;
            brand.list.push(item);
          });
          console.log(brand.list);
        }
        if (brand.key == "orderStatus") {
          this.statusType.forEach((i) => {
            let item = {};
            item.key = i.itemCode;
            item.name = i.itemName;
            brand.list.push(item);
          });
          console.log(brand.list);
        }
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
.order-container >>> .van-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.order-container >>> .van-tabs__content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

// .order-container >>> .van-tabs__content .van-tab__pane {
// flex: 1;
// overflow: hidden;
// display: flex;
// flex-direction: column;
// }

// .order-container >>> .van-tabs__content .van-tab__pane .van-pull-refresh {
// flex: 1;
// display: flex;
// flex-direction: column;
// overflow: auto;
// }
.order-container >>> .van-tabs .van-tabs__wrap {
  height: 88px;
}

.order-container >>> .van-tabs .van-tabs__wrap .van-tab {
  font-size: 32px;
  line-height: 45px;
  color: #333333;
}

.order-container >>> .van-tabs .van-tabs__wrap .van-tab--active {
  // font-size: 36px;
  color: #E12020;
}

.order-container >>> .van-popup {
  height: 100%;
  width: 576px;
}

.order-container >>> .van-empty__image {
  width: 360px;
  height: 360px;
}

.order-container >>> .van-empty__description {
  font-size: 0.32rem;
  line-height: 0.38rem;
}

.order-container {
  display: flex;
  flex-direction: column;
  height: 100%;

  .tabs-container {
    flex: 1;
    display: flex;
    overflow: hidden;
  }
}
</style>